import * as React from 'react';

import BaseForm from './baseForm';
import InputErrorMessage from './inputErrorMessage';

interface LoginFormProps {
  onSignIn: ({ email, password }: { email: string; password: string }) => Promise<void>;
  authError: any; // tslint:disable-line:no-any
}

interface LoginFormState {
  email: string;
  password: string;
  showErrors: boolean;
  loggingIn: boolean;
}

const defaultState: LoginFormState = {
  email: '',
  password: '',
  showErrors: false,
  loggingIn: false,
};

export default class LoginForm extends BaseForm<LoginFormProps, LoginFormState> {
  constructor(props: LoginFormProps) {
    super(props);
    this.state = { ...defaultState };
  }

  onSignIn = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!(this.state.email && this.state.password)) {
      this.setState({ showErrors: true });
      return;
    }
    this.setState({ loggingIn: true });
    this.props
      .onSignIn({
        email: this.state.email,
        password: this.state.password,
      })
      .catch(error => {
        this.setState({ ...defaultState });
        console.error('There was an error', error); // tslint:disable-line:no-console
      });
  };

  render(): JSX.Element {
    return (
      <form>
        <div className="field control">
          <label className="label">Email</label>
          <input
            className="input"
            type="email"
            placeholder="Email"
            name="email"
            value={this.state.email}
            onChange={this.onValueChange}
            autoFocus
          />
          <InputErrorMessage showError={!this.state.email && this.state.showErrors} message="Email is required." />
        </div>

        <div className="field control">
          <label className="label">Password</label>
          <input
            className="input"
            type="password"
            placeholder="Password"
            name="password"
            value={this.state.password}
            onChange={this.onValueChange}
            autoFocus
          />
          <InputErrorMessage
            showError={!this.state.password && this.state.showErrors}
            message="Password is required."
          />
        </div>

        <div className="field control">
          <button className="button is-dark" onClick={this.onSignIn}>
            Sign in
          </button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/loginForm.tsx